import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import BoxJob from './BoxJob';

class BoxConfigurationReservation extends Component {

  state = {
    reservedConfigurations: [],
    boxConfigurationId: null,
    deleting: null,
  };
  constructor(props) {
    super(props);
    this.state.reservedConfigurations = props.reservedConfigurations || [];
    this.state.boxConfigurationId = props.boxConfigurationId || null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reservedConfigurations !== this.props.reservedConfigurations) {
      this.setState({ reservedConfigurations: this.props.reservedConfigurations || [] });
    }
  }

  deleteReservation = async (reservationId) => {
    if (!window.confirm('Are you sure you want to delete this reservation?')) {
      return;
    }

    this.setState({ deleting: reservationId });

    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v4/box_configurations/${this.state.boxConfigurationId}/delete_reservation?reservation_id=${reservationId}`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      const result = await response.json();

      if (result.errors) {
        alert('Error deleting reservation: ' + (typeof result.errors === 'string' ? result.errors : JSON.stringify(result.errors)));
      } else {
        // Remove the deleted reservation from the list
        const updatedReservations = this.state.reservedConfigurations.filter(
          config => config.id !== reservationId
        );
        this.setState({ reservedConfigurations: updatedReservations });

        // Call parent callback if provided to refresh the full configuration
        if (this.props.onReservationDeleted) {
          this.props.onReservationDeleted(reservationId);
        }
      }
    } catch (error) {
      console.error('Error deleting reservation:', error);
      alert('Error deleting reservation: ' + error.message);
    } finally {
      this.setState({ deleting: null });
    }
  }

  render() {
    const { deleting } = this.state;

    return (
      <div key={`reservedConfigurations-${this.state.boxConfigurationId}`}>
        {this.state.reservedConfigurations.map((configuration, index) => (
          <div key={`reserved-configuration-${index}`}>
            <Row key={`reserved${index}`}>
              <Col md={10} className="text-left">
                <div>
                  {index > 0 && (<hr />)}
                  {configuration.qty} Box Job{configuration.qty === 1 ? "" : "s"} {configuration.status} on {moment(configuration.updated_at).format("MMM DD YYYY h:mm A")}
                </div>
              </Col>
              <Col md={2} className="text-right d-flex align-items-center justify-content-end">
                {configuration.status === 'reserved' && !configuration.box_job && (
                  <FontAwesomeIcon
                    icon={faTrash}
                    className={deleting === configuration.id ? "text-muted" : "text-danger"}
                    style={{ cursor: deleting === configuration.id ? 'not-allowed' : 'pointer' }}
                    title="Delete Reservation"
                    onClick={() => deleting !== configuration.id && this.deleteReservation(configuration.id)}
                  />
                )}
              </Col>
            </Row>
            {configuration.box_job &&
              <Row className="py-2" key={`reserved-box-job${index}`}>
                <Col md={12} className="text-left">
                  <div>
                    <BoxJob key={configuration.box_job.id} box_job={configuration.box_job}></BoxJob>
                  </div>
                </Col>
              </Row>
            }
          </div>
        ))}
      </div>
    );
  }
}

export default BoxConfigurationReservation;
